module.exports = __webpack_public_path__ + "static/media/Tread-life-warranty-badge.65ec784a.svg";